import React from 'react';
import AdminInquiryList from '../components/admin/inquiry/AdminInquiryList';

const AdminInquiry = () => {
    return (
        <AdminInquiryList />
    );
};

export default AdminInquiry;